export default "__VITE_ASSET__Bp$IXcCO__"